module.exports = __webpack_public_path__ + "static/media/boardtrac_plus_logo.9c46613d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boardtrac_plus_logo.svg
// module id = 71
// module chunks = 1